import { type LucideIcon, Plus } from 'lucide-react';

interface CTABannerProps {
  icon: LucideIcon;
  title: string;
  description: string;
  buttonText: string;
  onClick: () => void;
  buttonIcon?: LucideIcon;
}

export function CTABanner({
  icon: Icon,
  title,
  description,
  buttonText,
  onClick,
  buttonIcon: ButtonIcon = Plus,
}: CTABannerProps) {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="p-3 bg-white/20 rounded-xl">
          <Icon size={24} className="text-white" />
        </div>
        <div>
          <h3 className="text-white font-semibold">{title}</h3>
          <p className="text-indigo-100 text-sm">{description}</p>
        </div>
      </div>
      <button
        onClick={onClick}
        className="flex items-center gap-2 bg-white text-indigo-600 px-6 py-3 rounded-xl font-semibold hover:bg-indigo-50 transition-all"
      >
        <ButtonIcon size={18} />
        {buttonText}
      </button>
    </div>
  );
}
